// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportContainer.jsx" company="Izenda">  Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var m = require('mobx');
  var connect = require('share/enhancers/Izenda.Connect');
  var Tabs = require('share/components/controls/Izenda.Tab').Tabs;
  var Tab = require('share/components/controls/Izenda.Tab').Tab;
  var Loading = require('share/components/controls/Izenda.Loading');
  var Panel = require('share/components/controls/Izenda.Panel');
  var Reports = require('./Izenda.Reports');
  var Templates = require('./Izenda.Templates');
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  var LazyLoadingTree = require('../Tree/Izenda.LazyLoadingTree');
  var observer = require('mobx-react').observer;
  const { uniqueId } = require('lodash/fp');

  var SearchBox = connect()(function(props) {
    function onChange(filterText, e) {
      props.workspaceDetail[filterText] = e.target.value;
      $izenda('input', $izenda(ReactDOM.findDOMNode(this.refs.searchBox))).focus();
    }

    var filterText = props.isReport ? props.workspaceDetail.reportFilterText : props.workspaceDetail.templateFilterText;
    return (
      <SearchTextBox
        ref="searchBox"
        key={uniqueId()}
        className="search-box"
        value={filterText}
        onChange={onChange.bind(this, props.isReport ? 'reportFilterText' : 'templateFilterText')}
      />
    );
  });

  var ReportContainer = React.createClass({
    propTypes: {
      workspaceDetail: React.PropTypes.object.isRequired
    },

    getInitialState: function() {
      return {
        activeTabKey: 'reports',
        isReport: true
      };
    },

    /**
     * onchange tab
     * @param {Number} index
     * @param {String} tabPanel
     * @param {String} tabMenu
     * @param {String} activeTabKey
     */
    changeTab: function(index, tabPanel, tabMenu, activeTabKey) {
      this.setState({
        activeTabKey: activeTabKey,
        isReport: activeTabKey === 'reports'
      });
    },

    render: function() {
      var props = this.props;
      var localization = props.localization;

      return (
        <div className="u_tableCell u_paddingRight">
          {localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_PLEASE_SELECT_REPORT')}
          <Panel className="u_borderAll workspace-tree u_noMarginAll">
            <SearchBox workspaceDetail={props.workspaceDetail} isReport={this.state.isReport} />
            <Tabs activeTabKey={this.state.activeTabKey} onChange={this.changeTab}>
              {/* <Tab title='Lazy Loading Reports' tabKey='lazyreports' className="izenda-reportContainer">
                <LazyLoadingReport workspaceDetail={props.workspaceDetail} store={props.store} />
              </Tab>*/}
              <Tab title="Reports" tabKey="reports" className="izenda-reportContainer">
                <Reports workspaceDetail={props.workspaceDetail} store={props.store} />
              </Tab>
              <Tab title="Templates" tabKey="templates" className="izenda-reportContainer">
                <Templates workspaceDetail={props.workspaceDetail} />
              </Tab>
            </Tabs>
          </Panel>
        </div>
      );
    }
  });

  var LazyLoadingReport = observer(
    React.createClass({
      render: function() {
        var props = this.props;
        return (
          <LazyLoadingTree
            data={props.workspaceDetail.treeReports}
            isLastPage={props.workspaceDetail.isLastPage}
            getData={props.store.lazyLoadingReports.bind(props.store)}
          />
        );
      }
    })
  );

  module.exports = connect()(function(props) {
    return props.workspaceDetail && props.workspaceDetail.copyReport ? <ReportContainer {...props} /> : null;
  });
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/Report/Izenda.ReportContainer.jsx